import { DECIMAL_PLACES_OPTIONS } from "@features/builder/NodeDrawer/NodeForm/UnitFields/UnitField"

/** decoded representation of a node unit e.g. "{,.2f} tonnes" */
export type DecodedNodeUnit = {
  /** one of DECIMAL_PLACES_OPTIONS */
  decimalPlaces: string //
  usePercentageValue: boolean
  suffix?: string
  isEmpty?: boolean
}

export const isValidUnitFormat = (unit: string): boolean => {
  if (unit === "") return true

  if (!unit.startsWith("{,.")) return false

  const decimalNumber = unit[3] ?? ""
  if (!DECIMAL_PLACES_OPTIONS.includes(decimalNumber)) return false

  const decimalOrPercentageCharacter = unit[4] ?? ""
  if (!["f", "%"].includes(decimalOrPercentageCharacter)) return false

  if (unit[5] !== "}") return false

  // at this point unit should end or have suffix after a space
  if (unit[6] !== " " && unit[6] !== undefined) return false

  return true
}

export const decodeNodeUnit = (unit: string): Required<DecodedNodeUnit> => {
  if (!isValidUnitFormat(unit)) {
    throw new Error(`Unsupported unit format: "${unit}"`)
  }

  if (unit === "") {
    return { isEmpty: true, decimalPlaces: "2", usePercentageValue: false, suffix: "" }
  }

  return {
    isEmpty: false,
    decimalPlaces: unit[3]!,
    usePercentageValue: unit[4] === "%",
    suffix: unit.split(" ").slice(1).join(" "),
  }
}

export const encodeNodeUnit = ({
  usePercentageValue,
  decimalPlaces,
  isEmpty = false,
  suffix = "",
}: DecodedNodeUnit): string => {
  if (isEmpty) return ""

  const percentageCharacter = usePercentageValue ? "%" : "f"
  const suffixPart = suffix ? ` ${suffix}` : ""

  return `{,.${decimalPlaces}${percentageCharacter}}${suffixPart}`
}
